interface ClampPageParams {
  page: number;
  total: number;
  pageSize: number;
}

/**
 * Номер страницы в пределах списка. Когда список стал короче, antd сам
 * показывает последнюю страницу без вызова onChange, а номер в состоянии
 * остаётся старым — его нужно привести к числу страниц.
 */
export const clampPage = ({ page, total, pageSize }: ClampPageParams) => {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  return Math.min(Math.max(page, 1), pageCount);
};
